export default __webpack_public_path__ + "d283f9386fca10c5561170615ad63ea6.svg";